import Vue from 'vue'
import {
  OPEN_SECTION_DIALOG,
  OPEN_CATALOG_DIALOG,
  FETCH_EXHIBITOR_DETAIL,
  UPDATE_EXHIBITOR_DETAIL,
  FETCH_EXHIBITED_WORK_DETAIL,
  UPDATE_EXHIBITED_WORK_DETAIL,
  FETCH_CATALOG,
  FETCH_SECTION,
  UPDATE_CATALOG,
  ERROR_API
} from './actions'

const mutations = {
  [OPEN_SECTION_DIALOG] (state, payload) {
    Vue.set(state.catalog, 'results', [])
    Vue.set(state, 'visible', payload.visible)
    Vue.set(state, 'section', payload.section)
    Vue.set(state.section, 'loading', false)
  },
  [OPEN_CATALOG_DIALOG] (state, payload) {
    Vue.set(state, 'section', {})
    Vue.set(state, 'visible', payload.visible)
  },
  [FETCH_EXHIBITOR_DETAIL] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', [])
    Vue.set(payload.objectToIncrement, 'loading', true)
  },
  [UPDATE_EXHIBITOR_DETAIL] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', payload.results)
    Vue.set(payload.objectToIncrement, 'loading', false)
  },
  [FETCH_EXHIBITED_WORK_DETAIL] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', [])
    Vue.set(payload.objectToIncrement, 'loading', true)
  },
  [UPDATE_EXHIBITED_WORK_DETAIL] (state, payload) {
    Vue.set(payload.objectToIncrement, 'results', payload.results)
    Vue.set(payload.objectToIncrement, 'loading', false)
  },
  [FETCH_CATALOG] (state, payload) {
    Vue.set(state.catalog, 'results', [])
    Vue.set(state.catalog, 'loading', true)
  },
  [FETCH_SECTION] (state, payload) {
    Vue.set(state, 'section', {})
    Vue.set(state.section, 'loading', true)
  },
  [UPDATE_CATALOG] (state, payload) {
    Vue.set(state.catalog, 'results', payload.results)
    Vue.set(state.catalog, 'loading', false)
  },
  [ERROR_API] (state, payload) {
    Vue.set(state, 'error', payload.error)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/dialog/mutations.js